"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _excluded = ["className", "shape", "size", "imageUrl"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * The Avatar component is used to display an user picture (with a generic picture fallback).
 */
var Avatar = function Avatar(_ref) {
  var className = _ref.className,
      shape = _ref.shape,
      size = _ref.size,
      imageUrl = _ref.imageUrl,
      attributes = _objectWithoutPropertiesLoose(_ref, _excluded);

  var classes = (0, _clsx.default)('uk-avatar', "avatar--" + shape, size !== 'default' && "avatar--" + size, className);
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: classes
  }, attributes), imageUrl ? /*#__PURE__*/_react.default.createElement("img", {
    src: imageUrl,
    alt: ""
  }) : /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 480 480"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M347.5 250c0 59.375-48.125 107.5-107.5 107.5S132.5 309.375 132.5 250 180.625 142.5 240 142.5 347.5 190.625 347.5 250z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M421.194 535C413.917 424.125 335.575 336.834 240 336.834c-95.576 0-173.917 87.291-181.194 198.166h362.388z"
  })));
};

Avatar.propTypes = {
  /**
   * Shape of the avatar
   */
  shape: _propTypes.default.oneOf(['round', 'square']),

  /**
   * Size of the avatar
   */
  size: _propTypes.default.oneOf(['small', 'default', 'large']),

  /**
   * Hyperlink of the image
   */
  imageUrl: _propTypes.default.string
};
Avatar.defaultProps = {
  shape: 'round',
  size: 'default'
};
var _default = Avatar;
exports.default = _default;